<template>
  <section id="print">
    <div class="rowVar">
      <ul class="list-print">
        <template v-for="(variety, index) in varieties">
          <template v-if="$route.query.quantity">
            <li v-for="q in +$route.query.quantity" class="variety varietyRow">
              <div class="varietyContainer">
                <div :key="q * index + index" class="barcodeContainer">
                  <!-- <b class='title-shop'>کتونی ویکو</b> -->

                  <!-- <barcode
                    class="varietyBarcode"
                    fontSize="35"
                    width="6"
                    marginBottom="0"
                    marginTop="0"
                    elementTag="img"
                    :displayValue="true"
                    height="36"
                    :value="variety[0]"
                  >
                  </barcode> -->
                  <barcode
                    class="varietyBarcode"
                    fontSize="20"
                    width="3"
                    marginBottom="0"
                    marginTop="0"
                    elementTag="img"
                    :displayValue="true"
                    height="25"
                    :value="variety[0]"
                  >
                  </barcode>
                  <div class="info">
                    <textarea
                      rows="1"
                      type="text"
                      v-model="productName"
                      class="varietyPrice"
                      @input="adjustHeight"
                    ></textarea>
                    <div class="titleBox">
                      <!-- <span>-</span> -->
                      <div v-for="item in variety[5]" class="variety-box">
                        <span class="varName">
                          {{ item.value }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </template>
          <template v-else>
            <li v-for="q in variety[3]" class="variety varietyRow">
              <div class="varietyContainer">
                <div :key="q * index + index" class="barcodeContainer">
                  <!-- <b class='title-shop'>کتونی ویکو</b> -->

                  <!-- <barcode
                    class="varietyBarcode"
                    fontSize="35"
                    elementTag="img"
                    width="6"
                    marginBottom="0"
                    marginTop="0"
                    :displayValue="true"
                    height="36"
                    :value="variety[0]"
                  >
                  </barcode> -->
                   <barcode
                    class="varietyBarcode"
                    fontSize="20"
                    width="3"
                    marginBottom="0"
                    marginTop="0"
                    elementTag="img"
                    :displayValue="true"
                    height="22"
                    :value="variety[0]"
                  >
                  </barcode>
                  <span
                    class="priceName"
                    v-if="parsePrice(variety[8]) > parsePrice(variety[2])"
                  >
                    <del>
                      {{ variety[8] }}
                    </del>
                  </span>
                  <div class="info">
                    <textarea
                      rows="1"
                      type="text"
                      v-model="productName"
                      class="varietyPrice"
                      @input="adjustHeight"
                    ></textarea>
                    <div class="titleBox">
                      <!-- <span>-</span> -->

                      <div
                        v-for="(item, index) in variety[5]"
                        class="variety-box"
                      >
                        <span class="varName">
                          {{ item.value }}
                        </span>
                        <span v-if="index != variety[5].length - 1">-</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </template>
        </template>
      </ul>
    </div>
    <button id="printBtn" @click="print">پرینت</button>
  </section>
</template>

<script>
import printVarietiesImpl from "@@/core/pages/printVarieties/printVarietiesImpl";
export default {
  extends: printVarietiesImpl,
};
</script>

<style src="@@/core/pages/printVarieties/printVarietiesStyle.css"></style>
